module.exports = __webpack_public_path__ + "media/images/variantIcon-9fa709f7.svg";